import React from 'react'
import { Token } from '../Token'
import { parseFilename } from '../_utils/filename'
import {
  StyledExtension,
  StyledFilename,
  StyledFilenameShortcut,
} from './FileToken.styles'
import type { FileTokenInnerProps } from './FileToken.types'

export const FileTokenInner = ({
  fullFilename,
  includeInTabOrder,
  onClick,
  onClose,
  qaCloseBtn,
}: FileTokenInnerProps) => {
  const { filename, extension, isFilename } = parseFilename(fullFilename)
  const name = isFilename ? `${filename}.` : fullFilename

  return (
    <Token>
      <Token.Label onClick={onClick}>
        <StyledFilenameShortcut>
          <StyledFilename>{name}</StyledFilename>
          <StyledExtension>{extension}</StyledExtension>
        </StyledFilenameShortcut>
      </Token.Label>
      {includeInTabOrder && (
        <Token.Remove data-qa={qaCloseBtn} onClick={onClose} />
      )}
    </Token>
  )
}
